/**
 * Props for the loading skeleton.
 *
 * @since 1.0.0
 */
export interface LoadingRowsProps {
    rows?: number;
    label?: string;
}

const DEFAULT_ROW_COUNT = 5;
const ROW_WIDTHS = ['92%', '78%', '86%', '64%', '81%', '73%'];

/**
 * Placeholder bars shown while a card's data is in flight. The region is announced as busy
 * so a screen reader is told to wait rather than read a half-built table.
 *
 * @since 1.0.0
 * @param props - how many bars to draw and what to call the region
 * @returns the skeleton element
 */
export function LoadingRows({ rows = DEFAULT_ROW_COUNT, label = 'Loading' }: LoadingRowsProps) {
    return (
        <div aria-busy="true" aria-label={label} className="fkwd-skeleton-rows" role="status">
            {Array.from({ length: rows }, (_unused, index) => (
                <div
                    className="fkwd-skeleton"
                    key={index}
                    style={{ width: ROW_WIDTHS[index % ROW_WIDTHS.length] ?? '80%' }}
                />
            ))}
        </div>
    );
}
